import revive_payload_client_4sVQNw7RlN from "/builds/hatmeo/hatmeo-nuxt/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/hatmeo/hatmeo-nuxt/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/hatmeo/hatmeo-nuxt/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/builds/hatmeo/hatmeo-nuxt/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/builds/hatmeo/hatmeo-nuxt/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/hatmeo/hatmeo-nuxt/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/builds/hatmeo/hatmeo-nuxt/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/builds/hatmeo/hatmeo-nuxt/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/builds/hatmeo/hatmeo-nuxt/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/hatmeo/hatmeo-nuxt/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/builds/hatmeo/hatmeo-nuxt/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/builds/hatmeo/hatmeo-nuxt/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import element_plus_teleports_plugin_h4Dmekbj62 from "/builds/hatmeo/hatmeo-nuxt/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_1RNPi6ogby from "/builds/hatmeo/hatmeo-nuxt/.nuxt/element-plus-injection.plugin.mjs";
import plugin_AUP22rrBAc from "/builds/hatmeo/hatmeo-nuxt/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import element_plus_elM4AXquKi from "/builds/hatmeo/hatmeo-nuxt/plugins/element-plus.js";
import disable_right_click_CJtmRNdhWO from "/builds/hatmeo/hatmeo-nuxt/plugins/disable-right-click.js";
import nprogress_Oh8IVBvLxV from "/builds/hatmeo/hatmeo-nuxt/plugins/nprogress.js";
import set_config_l0rJWBdvgx from "/builds/hatmeo/hatmeo-nuxt/plugins/set-config.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  element_plus_teleports_plugin_h4Dmekbj62,
  element_plus_injection_plugin_1RNPi6ogby,
  plugin_AUP22rrBAc,
  element_plus_elM4AXquKi,
  disable_right_click_CJtmRNdhWO,
  nprogress_Oh8IVBvLxV,
  set_config_l0rJWBdvgx
]